import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getCityNemsisCode, ILocationNemsisLookupData, ILocationInfo } from './getCityNemsisCode.saga'
import { getLocationSearchState } from '../selectors'
import { ILocationSearchState } from '../store/locationSearch.types'
import { LocationSearchConstants } from '../store/locationSearch.constants'
import { getPickupAddressSelector } from '../../pickupAddress/selectors'
import { setCity } from '../../pickupAddress/store/pickupAddress.actions'
import { setErrorInfo } from '../store/locationSearch.actions'
import { PickupAddressConstants } from '../../pickupAddress/store/pickupAddress.constants'
import { IPickupAddressState } from '../../pickupAddress/store/pickupAddress.types'
import Logger from '../../../services/logger.service'
import { ICity } from '../../../common/common.types'
import { areObjectsEqual } from '../../../utilities/object.util'

export function* getRefCityNemsisCode() {
  const { errorMsgsMap }: ILocationSearchState = yield select(getLocationSearchState)
  const { city, state, county }: IPickupAddressState = yield select(getPickupAddressSelector)
  const locationInfo: ILocationInfo = { city, state, county }
  try {
    if (city) {
      const nemsisData: ILocationNemsisLookupData = yield call(getCityNemsisCode, locationInfo)
      const updatedCity: ICity = { ...city, nemsisCode: nemsisData.city?.nemsisCode || '' }
      errorMsgsMap[PickupAddressConstants.SET_CITY] = nemsisData.cityError
      errorMsgsMap[PickupAddressConstants.SET_STATE] = nemsisData.stateError
      errorMsgsMap[PickupAddressConstants.SET_COUNTY] = nemsisData.countyError
      if (areObjectsEqual(city, updatedCity)) {
        return
      }
      yield put(setCity(updatedCity))
      yield put(setErrorInfo(errorMsgsMap))
    }
  } catch (e) {
    Logger.error(`Error getRefCityNemsisCode', ${e}`)
  }
}

export function* getRefCityNemsisCodeSaga() {
  yield takeLatest(
    [
      LocationSearchConstants.GET_REF_CITY_NEMSIS_CODE,
      PickupAddressConstants.SET_PICKUP_ADDRESS_STATE,
      PickupAddressConstants.SET_COUNTY,
      PickupAddressConstants.SET_STATE,
    ],
    getRefCityNemsisCode
  )
}
